<template>
    <b-card
        class="apprentice-simple-card dashboard-invites-check-widget"
        no-body
        header-class="dashboard-invites-check-widget-header">
        <template #header>
            <div class="component-title">
                <h5 class="title">{{ $t('dashboard.to_do_list') }}</h5>
            </div>
        </template>

        <!--        groepjesmaaktool uitnodigingen-->
        <div
            class="invites"
            v-if="invitesIn.length">
            <div
                class="invite"
                v-for="invite in invitesIn">
                <div class="icon d-none d-lg-block"><i class="fad fa-fw fa-user"></i></div>
                <div class="title">
                    {{ displayGroupName(invite.sub.group_id) }}
                    <div class="invite-type muted-text">{{ $t('dashboard.approve_request') }}</div>
                </div>
                <div class="invite-show">
                    <b-button
                        class="btn-open"
                        v-b-tooltip="$t('common.view')"
                        variant="primary-icon-only"
                        href="#">
                    </b-button>
                </div>
                <a
                    class="clickable"
                    href="/invites/check/"></a>
            </div>
        </div>

        <!--        rubrics uitnodigingen -->
        <div
            class="rubrics-invites"
            v-if="surveysIn.length">
            <div v-for="survey in surveysIn">
                <div v-for="survey_user in survey.rubric_survey_users">
                    <div v-if="survey_user.rubric_forms.length">
                        <div
                            class=""
                            v-for="form in survey_user.rubric_forms">
                            <div class="btn-check-list icon remove-icon-margin"></div>
                            <div class="title">
                                {{ form.rubric.title }}
                                <div class="invite-type muted-text">Vul een rubric in</div>
                            </div>
                            <div class="invite-show">
                                <b-button
                                    class="btn-open btn-icon-only"
                                    v-b-tooltip="$t('common.view')"
                                    variant="primary-icon-only"
                                    href="#">
                                </b-button>
                            </div>

                            <a
                                class="clickable"
                                :href="getSurveyLink(survey.rubric_id, form.id)"></a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!--        geen uitnodigingen gevonden -->
        <div
            class="not-found with-header empty-invites-list"
            v-if="surveysIn.length === 0 && invitesIn.length === 0">
            <div class="alert-notice">{{ $t('dashboard.no_to_dos_found') }}</div>
        </div>
    </b-card>
</template>

<script>
export default {
    name: 'design-2021-dashboard-project-invites-check-widget-component',
    props: {
        invitesIn: Array,
        groupsIn: Array,
        surveysIn: Array,
    },
    methods: {
        getSurveyLink(rubric_id, form_id) {
            return this.routes.rubricFormEdit(rubric_id, form_id);
        },
        displayGroupName(id) {
            for (const group of this.groupsIn) {
                if (group.id === id) {
                    return group.name;
                }
            }
            return null;
        },
    },
};
</script>

<style scoped lang="scss">
.dashboard-invites-check-widget {
    border: none;
    margin-top: map-get($grid-gutter-spacing, 'twenty-one');

    .dashboard-invites-check-widget-header {
        border: none;
        background-color: transparent;

        .title {
            margin-right: map-get($grid-gutter-spacing, 'fifteen');
            align-self: flex-start;

            & + .btn {
                margin-right: 0;
            }
        }
    }

    .info-text {
        color: $text-muted-color;
        font-size: $default-font-size;
    }

    .info-text,
    .invite,
    .rubric-invite {
        margin-bottom: map-get($grid-gutter-spacing, 'ten');
    }

    .invite,
    .rubric-invite {
        display: flex;
        justify-content: flex-start;
        align-content: center;
        font-size: 1.3125rem;
        position: relative;
        padding-top: map-get($grid-gutter-spacing, 'ten');

        .icon {
            align-self: center;
            padding: map-get($grid-gutter-spacing, 'ten');
            background: $secondary-background-color;
            border-radius: $border-radius-content;
            color: $primary;
        }

        .title {
            font-size: $default-font-size;
            font-family: $headings-font-family;
            line-height: 1;
            align-self: center;
        }

        .invite-show,
        .invite-action {
            align-self: center;
            margin-left: auto;

            .btn {
                font-size: 1.3125rem;
            }
        }

        &:hover {
            cursor: pointer;

            .icon {
                color: $inverse-info;
            }

            .title {
                font-weight: $font-weight-medium;
                color: $primary;
            }

            .invite-show .btn {
                color: $nav-link-color;
            }
        }
    }

    .rubric-invites {
        margin-top: map-get($grid-gutter-spacing, 'twenty-one');
    }
}

.btn-check-list:before {
    margin-right: 0;
}

@media (min-width: map-get($grid-breakpoints, 'md')) {
    .dashboard-invites-check-widget {
        .component-title {
            flex-direction: column;

            .title {
                margin-right: map-get($grid-gutter-spacing, 'twenty-one');
            }

            .btn {
                align-self: flex-end;
                margin-right: 0;
            }
        }
    }
}

@media (min-width: map-get($grid-breakpoints, 'lg')) {
    .invite,
    .rubric-invite {
        .title {
            margin-right: map-get($grid-gutter-spacing, 'ten');
        }
    }

    .page-wrapper.navbar-toggled {
        .invite,
        .rubric-invite {
            .title {
                margin-left: map-get($grid-gutter-spacing, 'ten');
            }

            .icon {
                display: flex !important;
            }
        }
    }
}

@media (min-width: map-get($grid-breakpoints, 'xl')) {
    .dashboard-invites-check-widget {
        max-width: 450px;
        width: 100%;
        align-self: center;

        .component-title {
            flex-direction: row;
        }

        .invite,
        .rubric-invite {
            .title {
                margin-left: map-get($grid-gutter-spacing, 'fifteen');
                margin-right: map-get($grid-gutter-spacing, 'fifteen');
            }
        }
    }
}
</style>
